module.exports = __webpack_public_path__ + "static/media/ricky-selfie.d7661e40.png";